import type { AxiosError } from "axios";

import { isOfferIsNotAvailableAnymoreError } from "@/app/lib/assertions";
import { GeneralPageError } from "@/components/Errors/GeneralPageError";
import { OfferNotAvailableError } from "@/components/Errors/OfferNotAvailableError";
import type { OfferIsNotAvailableAnymoreOutputDto } from "@/types/codegen";

interface FlightOfferErrorProps {
  error: Error | AxiosError<OfferIsNotAvailableAnymoreOutputDto>;
}

export const FlightOfferError = ({ error }: FlightOfferErrorProps) => {
  if (isOfferIsNotAvailableAnymoreError(error)) {
    return <OfferNotAvailableError variant="flight" />;
  }

  return (
    <GeneralPageError
      backOptions={{ to: "/", search: { category: "flights" } }}
    />
  );
};
